import { NextPage } from "next"
import Head from "next/head"
import { useRouter } from "next/router"
import { DefaultLayout } from "src/components/Layout"
import { CompanyList } from "src/features/companies/components/CompanyList"

const CompanyListPage: NextPage = () => {
  const router = useRouter()

  if (!router.isReady) {
    return null
  }

  return (
    <DefaultLayout>
      <Head>
        <title>事業者一覧 | for CS</title>
      </Head>
      <div className="bg-gray-50" style={{ height: "calc(100vh - 90px)" }}>
        <div className="mx-auto max-w-10/12 px-4 py-6 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">事業者一覧</h1>

          <div className="rounded-lg bg-white shadow-sm">
            <div className="p-6">
              <CompanyList />
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}

export default CompanyListPage
